var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectWorkflow01 = function SvgSelectWorkflow01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "select_workflow-01_svg2__a",
    x1: 29.49,
    x2: 154.67,
    y1: 194.78,
    y2: 82.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M186.67 139.59h-7.5V112c0-11.94-11.4-22.41-24.4-22.41h-50.6v-25h11.67c7.36-.01 13.32-5.98 13.33-13.33v-27.5c0-7.36-5.98-13.32-13.33-13.33H84.17c-7.36.01-13.32 5.98-13.33 13.33v27.5c.01 7.36 5.98 13.32 13.33 13.33h11.67v25h-50.6c-13 0-24.4 10.47-24.4 22.41v27.59h-7.5c-7.36 0-13.32 5.98-13.33 13.33v23.33c.01 7.36 5.98 13.32 13.33 13.33h23.33c7.36 0 13.32-5.98 13.33-13.33v-23.33c0-7.36-5.98-13.32-13.33-13.33h-7.5V112c0-8.06 8.48-14.08 16.07-14.08h50.6v41.67h-7.5c-7.36 0-13.32 5.98-13.33 13.33v23.33c.01 7.36 5.98 13.32 13.33 13.33h23.33c7.36 0 13.32-5.98 13.33-13.33v-23.33c-.01-7.36-5.98-13.32-13.33-13.33h-7.5V97.92h50.6c7.59 0 16.07 6.02 16.07 14.08v27.59h-7.5c-7.36 0-13.32 5.98-13.33 13.33v23.33c0 7.36 5.98 13.32 13.33 13.33h23.33c7.36 0 13.32-5.98 13.33-13.33v-23.33c0-7.36-5.97-13.32-13.33-13.33m-150.01 8.34c2.76 0 5 2.24 5 5v23.33c0 2.76-2.24 5-5 5H13.32c-2.76 0-5-2.24-5-5v-23.33c0-2.76 2.24-5 5-5zm75.01 0c2.76 0 5 2.24 5 5v23.33c0 2.76-2.24 5-5 5H88.34c-2.76 0-5-2.24-5-5v-23.33c0-2.76 2.24-5 5-5zM84.16 56.25c-2.76 0-5-2.24-5-5v-27.5c0-2.76 2.24-5 5-5h31.67c2.76 0 5 2.24 5 5v27.5c0 2.76-2.24 5-5 5zm107.51 120.01c0 2.76-2.24 5-5 5h-23.33c-2.76 0-5-2.24-5-5v-23.33c0-2.76 2.24-5 5-5h23.33c2.76 0 5 2.24 5 5z",
    style: {
      fill: "url(#select_workflow-01_svg2__a)"
    }
  }));
};
export default SvgSelectWorkflow01;